<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>
        财务专家管理
      </el-breadcrumb-item>
      <el-breadcrumb-item>专家签字密码管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-form label-position="left" label-width="100px" :model="passForm" :rules="passFormRules">
        <div class="notice">
          提示：初始密码为1234
        </div>
        <el-form-item label="原密码" prop="passOld">
          <el-input v-model="passForm.passOld"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="passNew">
          <el-input v-model="passForm.passNew"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="passNewConfirm">
          <el-input v-model="passForm.passNewConfirm" @blur="confirmPass()" id="id-pass-confirm"></el-input>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="editPass()">确认修改</el-button>
    </el-card>
    <el-card>
      <h4>签名预览</h4>
      <div>{{ pngMessage }}</div>
      <img :src=png alt="" />
      <div class="div-file">
        <h5>注意：上传的签名文件必须为png格式！</h5>
        <div class="div-upload">
          <input type="file" value="" class="input-upload" @change="uploadFile">
          <el-button type="primary" class="button-upload">上传签名
            <i class="el-icon-upload el-icon--right"></i>
          </el-button>
        </div>
      </div>

    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userid: '',
      png: '',
      pngMessage: '',
      passForm: {},
      passFormRules: {
        passOld: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        },],
        passNew: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        },],
        passNewConfirm: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }],
      },
    }
  },

  async created() {
    // 没有记录，先插入一条，默认密码1234，models中定义的
    this.userid = localStorage.getItem('userid')
    let res = await this.axios.get('/expertSignPass/?userid=' + this.userid)
    res = res.data.results
    if (res.length == 0) {
      let data = {
        userid: this.userid,
        role_id: 5
      }
      let resPost = await this.axios.post('/expertSignPass/', data)
      if (resPost.status != 201) {
        return this.$message.error('更新资源错误，请稍后刷新页面再试！')
      }
    } else {
      if (!res[0].png) {
        // 签名图片为空
        this.pngMessage = '您还没有上传签名，请点击下方的上传签名按钮上传！'
      } else {
        this.png = res[0].png
      }
    }
  },

  methods: {
    // 判断
    confirmPass() {
      if (this.passForm.passNew != this.passForm.passNewConfirm) {
        this.$message.warning('密码不一致，请重新填写！')
        this.passForm.passNewConfirm = ''
        setTimeout(() => {
          document.getElementById('id-pass-confirm').focus()
        }, 500);
      }
    },

    // 修改密码
    async editPass() {
      let resGet = await this.axios.get('/expertSignPass/?userid=' + this.userid)
      if (resGet.status == 200) {
        resGet = resGet.data.results[0]
      }
      if (this.passForm.passOld != resGet.password) {
        return this.$message.error('原始密码错误，请重新输入！')
      }
      resGet.password = this.passForm.passNew
      let resPut = await this.axios.put(`/expertSignPass/${this.userid}/`, resGet)
      if (resPut.status == 200) {
        this.$message.success('修改成功！')
      }
    },

    // 上传签名
    async uploadFile(e) {
      if (e.target.files[0].name.slice(-3) != 'png') {
        return this.$message.error('请上传png格式的图片！')
      }
      let formData = new FormData();
      let data = JSON.stringify({
        pid: '专家签名/' + this.userid
      })
      formData.append('file', e.target.files[0]);
      formData.append('data', data); // 上传文件的同时， 也可以上传其他数据
      let url = `/uploadFile/`;
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      };

      let res = await this.axios.post(url, formData, config)
      if (res.status == 200) {
        let data = {
          userid: this.userid,
          path: this.userid + '/' + e.target.files[0].name
          // ./uploadfiles/专家签名/chenli1/专家陈.png    后端也要配置
        }
        let resGen = await this.axios.post('/genExpertPng/', data)
        if (resGen.status == 200) {
          setTimeout(() => {
            location.reload()
          }, 500)
        }
      } else {
        return this.$message.error('上传文件错误')
      }
    },
  }
}

</script>

<style lang="less">
.el-card {
  margin-top: 20px;

  .el-form {
    .el-input {
      width: 300px;
    }

    .notice {
      margin-left: 5px;
      margin-bottom: 20px;
    }
  }
}


.div-upload {
  height: 47px;

  .input-upload {
    width: 101px;
    height: 33px;
    position: absolute;
    z-index: 1;
    opacity: 0;
  }

  .button-upload {
    position: absolute;
  }

  .button-upload:hover {
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/finance/FinanceSignPass.vue